import styled, { css } from 'styled-components';
import { RowTable } from '../../../../func/components/Table';
import { ReportFormatNumber } from '../../../../func/Function';
import { useState } from 'react';
import { linkSync } from 'fs';
import MoreButton from '../../../components/moreButton/MoreButton';

const Category = ['구분', '매각기일', '최저매각가격', '결과'];

const attachmentIcon = '/assets/images/icon/Icon_Attachment.svg';

const transformData = (item: {
  no: string;
  date: string;
  minprice: string;
  result: string;
}) => {
  return [
    { key: Category[0], value: item.no },
    { key: Category[1], value: item.date },
    {
      key: Category[2],
      value: item.minprice.includes('매각')
        ? item.minprice.split('-')[0] +
          '-' +
          (ReportFormatNumber(item.minprice.split('-')[1]) || null)
        : ReportFormatNumber(item.minprice) || null,
    },
    { key: Category[3], value: item.result ? item.result : '-' },
  ];
};

const SaleInfo = ({ data, linkSet }: { data: any[]; linkSet: any }) => {
  const [showAll, setShowAll] = useState(false);
  const initialData = data.slice(-4);

  const showData = showAll ? data : initialData;

  const formatPriceNumber = (price: string) => {
    const value = price.includes('매각') ? price.split('-')[1] : price;

    return ReportFormatNumber(value);
  };

  const formatDate = (date: string) => {
    const clean = date.replace(/-/g, '.');
    const [yyyy, mm, dd] = clean
      .split('.')
      .map((part) => part.padStart(2, '0'));
    return `${yyyy}.${mm}.${dd}`;
  };

  return (
    <Container id="기일현황">
      <TitleBox>
        기일 현황
        {linkSet?.buttonLink?.assetDetail && (
          <DetailButton
            onClick={() => {
              if (linkSet?.buttonLink?.assetDetail) {
                window.open(linkSet.buttonLink.assetDetail, '_blank');
              }
            }}
          >
            매각물건명세서 보기 {'>'}
          </DetailButton>
        )}
      </TitleBox>
      <Content>
        <Item>
          매각기일
          <ItemContent>
            <span>최저매각가격</span>
            <span>결과</span>
          </ItemContent>
        </Item>
        {showData.map((item, idx) => (
          <Item key={idx}>
            <ItemContent>
              <Dot $isLast={idx === showData.length - 1} />
              <SaleDate $isLast={idx === showData.length - 1}>
                {formatDate(item.date)}
              </SaleDate>
            </ItemContent>
            <ItemContent>
              <SaleCost
                $isLast={idx === showData.length - 1}
                $isSold={item.result === '매각'}
              >
                {item.result === '매각' && <Text>낙찰금</Text>}
                {formatPriceNumber(item.minprice)}
              </SaleCost>
              <SaleResult
                result={
                  item.result
                    ? item.result
                    : !item.result && idx === 0 && '진행'
                }
              >
                {item.result}
                {!item.result && idx === 0 && '진행'}
              </SaleResult>
            </ItemContent>
          </Item>
        ))}
      </Content>
      {data.length > 3 && (
        <MoreButton
          name="기일현황"
          showAll={showAll}
          setShowAll={setShowAll}
          sectionId="기일현황"
        />
      )}
    </Container>
  );
};

export default SaleInfo;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
  background-color: #fff;
`;

const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const DetailButton = styled.button`
  padding: 5px 10px;
  border-radius: 8px;
  background: #0220470d;
  border: none;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #3e5463;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Item = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #f3f5f7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const Dot = styled.div<{ $isLast?: boolean }>`
  width: 6px;
  height: 6px;
  aspect-ratio: 1/1;
  background-color: ${({ $isLast }) => ($isLast ? '#008AFF' : '#37383C29')};
  border-radius: 9999px;
`;

const SaleDate = styled.div<{ $isLast?: boolean }>`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: ${({ $isLast }) => ($isLast ? '#222' : '#37383C9C')};
`;

const ItemContentRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-end;
`;

const Text = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #222;
`;

const SaleCost = styled.div<{ $isLast?: boolean; $isSold?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: ${({ $isSold, $isLast }) =>
    $isSold ? '#008AFF' : $isLast ? '#222' : '#37383C9C'};
`;

const SaleResult = styled.div<{ result?: string }>`
  width: 26px;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  ${({ result }) => {
    switch (result) {
      case '매각':
        return css`
          color: #008aff;
        `;
      case '유찰':
        return css`
          color: #f45551;
        `;
      case '진행':
        return css`
          color: #489f68;
        `;
      default:
        return css`
          color: #37383c9c;
        `;
    }
  }}
`;
